/**
 * @file Conversion Data
 */
import {
  moneyFormatter,
  effectCostFomatter,
  effectCountFomatter,
  effectRateFormatter,
  percentCellFormatter,
  integerValueFormatter,
  moneyFormatterWithUnit,
  getStatisticDataKey,
  isPcmWebStatistic,
} from 'src/const/statistics/formatters';
import { COLUMN_WIDTH } from 'src/const/column-width';
import { isDeepConvertWhite } from 'src/const/whiteList';
import { campaignType } from 'src/const/state/campaign';
import SkanNumberHover from 'src/components/dashboard/perf/skan-num-hover';


// dc下的mmp是转化类数据三个层级hover文案一样
// in app event dc增加hover
const conversionDcHover = (h, row, key, formatter) => {
  const isMMPDcData = row?.dedicate_type === campaignType.dedicatedCampaign;
  const isPcmWeb = isPcmWebStatistic(row);
  const itemKey = getStatisticDataKey(row, key);
  const hintKey = isPcmWeb ? 'module_dc_hover_pcm' : 'module_dc_hover_idmatching';
  const numberData = formatter(row, {}, itemKey);
  const formatNumberData = typeof numberData === 'undefined' ? '-' : numberData;
  if (!isMMPDcData && !isPcmWeb) {
    return (
      <div class="display-status">
        <div class="main-status">
          {formatNumberData}
        </div>
      </div>);
  }
  return (
    <SkanNumberHover
      isMMPDcData={isMMPDcData}
      isPcmWeb={isPcmWeb}
      tooltipTextKey={hintKey}
      numberData={numberData}
    />
  );
};
export const EnumConversionData = [
  {
    i18nPath: 'list_convert_count', // 转化数
    hint: 'campaign_hover_stat_data.convert_cnt',
    key: 'time_attr_convert_cnt',
    'min-width': COLUMN_WIDTH.M,
    sortable: true,
    formatter: integerValueFormatter,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'time_attr_convert_cnt', integerValueFormatter);
      },
    },
  },
  {
    i18nPath: 'list_convert_cost', // 转化成本
    hint: 'campaign_hover_stat_data.convert_cost',
    key: 'time_attr_conversion_cost',
    'min-width': COLUMN_WIDTH.S,
    sortable: true,
    type: 'component',
    formatter: moneyFormatterWithUnit,
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'time_attr_conversion_cost', moneyFormatterWithUnit);
      },
    },
  },
  {
    i18nPath: 'list_convert_rate', // 转化率
    hint: 'campaign_hover_stat_data.convert_rate',
    key: 'time_attr_conversion_rate',
    'min-width': COLUMN_WIDTH.S,
    sortable: true,
    type: 'component',
    formatter: percentCellFormatter,
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'time_attr_conversion_rate', percentCellFormatter);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_conversions', // 未对回转化数
    hint: 'campaign_hover_stat_data.convert_cnt',
    key: 'convert_cnt',
    'min-width': 160,
    sortable: true,
    formatter: integerValueFormatter,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'convert_cnt', integerValueFormatter);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_cpa', // 未对回转化成本
    hint: 'campaign_hover_stat_data.convert_cost',
    key: 'conversion_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'conversion_cost', moneyFormatterWithUnit);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_cvr', // 未对回转化率
    hint: 'campaign_hover_stat_data.convert_rate',
    key: 'conversion_rate',
    'min-width': 160,
    sortable: true,
    formatter: percentCellFormatter,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return conversionDcHover(h, this.row, 'conversion_rate', percentCellFormatter);
      },
    },
  },
  {
    i18nPath: 'list_effect_count', // 成效数
    key: 'time_attr_effect_cnt',
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const isTimeAttr = true; // 是否是转化对回数据
        return effectCountFomatter(this.row, h, isTimeAttr, this.$t, this);
      },
    },
  },
  {
    i18nPath: 'list_effect_cost', // 成效成本
    key: 'time_attr_effect_cost',
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    type: 'component',
    formatter: moneyFormatterWithUnit,
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const isTimeAttr = true; // 是否是转化对回数据
        return effectCostFomatter(this.row, h, isTimeAttr);
      },
    },
  },
  {
    i18nPath: 'list_effect_rate', // 成效率
    key: 'time_attr_effect_rate',
    formatter: percentCellFormatter,
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const isTimeAttr = true; // 是否是转化对回数据
        return effectRateFormatter(this.row, h, isTimeAttr);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_result', // 未对回成效数
    key: 'effect_cnt',
    sortable: false,
    'min-width': COLUMN_WIDTH.XXL,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return effectCountFomatter(this.row, h, false, this.$t, this);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_cpr', // 未对回成效成本
    key: 'effect_cost',
    sortable: false,
    type: 'component',
    'min-width': COLUMN_WIDTH.XXL,
    formatter: moneyFormatterWithUnit,
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return effectCostFomatter(this.row, h);
      },
    },
  },
  {
    i18nPath: 'time_attr_real_time_results_rate', // 未对回成效率
    key: 'effect_rate',
    formatter: percentCellFormatter,
    'min-width': COLUMN_WIDTH.XXL,
    sortable: false,
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        return effectRateFormatter(this.row, h);
      },
    },
  },
  {
    i18nPath: 'list_deep_convert_count', // 深度转化次数
    key: 'time_attr_deep_convert_cnt',
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    hide: () => !isDeepConvertWhite(),
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const isMMPDcData = this.row.dedicate_type === campaignType.dedicatedCampaign;
        const time_attr_deep_convert_cnt = getStatisticDataKey(this.row, 'time_attr_deep_convert_cnt');
        const deep_convert_cnt_note = getStatisticDataKey(this.row, 'deep_convert_cnt_note');
        const numberData = integerValueFormatter(this.row, {}, time_attr_deep_convert_cnt);
        const formatNumberData = typeof numberData === 'undefined' ? '-' : numberData;
        if (!isMMPDcData) {
          return (
            <div class="display-status">
              <div class="main-status">
                {formatNumberData}
              </div>
              <div class="bid-status">{deep_convert_cnt_note}</div>
            </div>);
        }
        return (
          <SkanNumberHover
            isMMPDcData={isMMPDcData}
            isShowNote={true}
            tooltipTextKey='module_dc_hover_idmatching'
            numberData={numberData}
            noteData={deep_convert_cnt_note}
          />
        );
      },
    },
  },
  {
    i18nPath: 'list_deep_convert_cost', // 深度转化成本
    key: 'time_attr_deep_convert_cost',
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    hide: () => !isDeepConvertWhite(),
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const isMMPDcData = this.row.dedicate_type === campaignType.dedicatedCampaign;
        const time_attr_deep_convert_cost = getStatisticDataKey(this.row, 'time_attr_deep_convert_cost');
        const deep_convert_cost_note = getStatisticDataKey(this.row, 'deep_convert_cost_note');
        const numberData = moneyFormatter(this.row, {}, time_attr_deep_convert_cost);
        const formatNumberData = typeof numberData === 'undefined' ? '-' : numberData;
        if (!isMMPDcData) {
          return (
            <div class="display-status">
              <div class="main-status">
                {formatNumberData}
              </div>
              <div class="bid-status">{deep_convert_cost_note}</div>
            </div>);
        }
        return (
          <SkanNumberHover
            isMMPDcData={isMMPDcData}
            isShowNote={true}
            tooltipTextKey='module_dc_hover_idmatching'
            numberData={numberData}
            noteData={deep_convert_cost_note}
          />
        );
      },
    },
  },
  {
    i18nPath: 'list_deep_cvr', // 深度转化率
    key: 'time_attr_deep_cvr',
    'min-width': COLUMN_WIDTH.XXL,
    sortable: true,
    formatter: percentCellFormatter,
    hide: () => !isDeepConvertWhite(),
    type: 'component',
    component: {
      props: {
        row: { type: Object, required: true },
      },
      render(h) {
        const time_attr_deep_cvr = getStatisticDataKey(this.row, 'time_attr_deep_cvr');
        const deep_convert_cost_note = getStatisticDataKey(this.row, 'deep_convert_cost_note');
        const isMMPDcData = this.row.dedicate_type === campaignType.dedicatedCampaign;
        const numberData = time_attr_deep_cvr;
        const formatNumberData = typeof numberData === 'undefined' ? '-' : numberData;
        if (!isMMPDcData) {
          return (
            <div class="display-status">
              <div class="main-status">
                {formatNumberData}
              </div>
              <div class="bid-status">{deep_convert_cost_note}</div>
            </div>);
        }
        return (
          <SkanNumberHover
            isMMPDcData={isMMPDcData}
            isShowNote={true}
            tooltipTextKey='module_dc_hover_idmatching'
            numberData={numberData}
            noteData={deep_convert_cost_note}
          />
        );
      },
    },
  },
];
